import { render, staticRenderFns } from "./ViewEventPage.vue?vue&type=template&id=7969254d&"
import script from "./ViewEventPage.vue?vue&type=script&lang=js&"
export * from "./ViewEventPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports